<span [class]="[iconPrefix(), primeIcon()]" style="font-size: {{this.remSize()}}" (click)="this.click()"></span>
